import React, {Component} from 'react';
import {Api} from '../../api';
import {getAuthToken} from '../../utils';
import {connect} from 'react-redux';
import './CheckBalance.scss';
import TextFieldInput from "../../components/Common/TextFieldInput";


class CheckBalance extends Component {

    state = {
        countries: [],
        country: '',
        countryId: null,
        providerId: null,
        providers: [],
        provider: '',
        companyTypeList: [],
        companyType: '',
        jurisdictionOfIncorporations: [],
        personalData: {
            companyType: '',
            firstName: '',
            id: '',
            jurisdiction: '',
            lastName: '',
            taxIDNumber: '',
        },
        userInfo: {
            systemWalletAddress: ''
        },
        confirmed: false,
        isOpenModal: false,
        OSName: null,
        isLoading: true,
    };

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidUpdate() {
    }

    componentWillMount() {
        this.props.handleLoader(true);
    }

    componentDidMount() {
        console.log('I\'m here in check balance');
        const authToken = getAuthToken();
        Api.get('user/payment-amount', authToken)
            .then((response) => {
                this.setState({paymentAmount: response.data.paymentAmount});
                Api.get('user/info', authToken)
                    .then((response) => {
                        // console.log(response.data.userCertificates.length);
                        const userInfo = response.data;
                        this.setState({userInfo: userInfo, isLoading: false});
                        //Is user active
                        if (userInfo.userStatus === 'ACTIVE') {
                            this.props.history.push('/user/personal-data/info');
                        } else {
                            setTimeout(() => this.props.handleLoader(false), 200);
                            this.interval = setTimeout(() => this.checkStatus(), 2000);
                        }
                    }).catch((error) => {
                    console.log(error);
                });
            }).catch((error) => {

        });
    }

    checkStatus() {
        const authToken = getAuthToken();
        Api.get('user/info', authToken)
            .then((response) => {
                const userInfo = response.data;
                //Is user active
                if (userInfo.userStatus === 'ACTIVE') {
                    this.props.history.push('/user/personal-data/info');
                } else {
                    this.interval = setTimeout(() => this.checkStatus(), 2000);
                }
            }).catch((error) => {
            console.log(error);
            this.interval = setTimeout(() => this.checkStatus(), 2000);
        });
    }

    render() {
        const {paymentAmount, userInfo, isLoading} = this.state;

        return (
            <div className="content">
                {!isLoading ?
                    <div>
                        <h3>
                            For the full use of the application you have to add account balance.
                        </h3>
                        <h2>
                            Account balance should be {paymentAmount / 100000000} BTC.
                        </h2>
                        <div className="row">
                            <div className="col-lg-5" style={{paddingRight: '0px'}}>
                                <TextFieldInput name='btcFundingWallet'
                                                id={'btcFundingWallet'}
                                                label='Btc wallet'
                                                disabled={true}
                                                required={true}
                                                value={userInfo.systemWalletAddress}
                                                classes='width-328'/>
                            </div>
                            <div className="col-lg-1" style={{paddingLeft: '0px', top: '6px'}}>
                                <svg style={{height: '35px', width: '35px'}} aria-hidden="true"
                                     focusable="false" data-prefix="far" data-icon="copy"
                                     onClick={(e) => {
                                         this.copyBtcAddress(e)
                                     }}
                                     className="copy-svg" role="img"
                                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <path fill="currentColor"
                                          d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"></path>
                                </svg>
                            </div>
                        </div>
                    </div> : <div></div>
                }
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(CheckBalance);


// WEBPACK FOOTER //
// ./src/views/CheckBalance/CheckBalance.js